import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Frame1e7t2kcdb3wu7 as Frame,
  RowOrCol3a33s3yce2tuv as RowOrCol,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  forEachUpdating2xo34s2yjc7ia as forEachUpdating,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { NothingHereSemantic_getInstance3tro8v94k1jgs as NothingHereSemantic_getInstance } from '../../theming/appTheme.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
  BoldSemantic_getInstance3sy4hmow8wwn9 as BoldSemantic_getInstance,
  SmallBodySemantic_getInstance13vsg4635cu56 as SmallBodySemantic_getInstance,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
} from '../../theming/Titles.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../../sdk/UserSession.mjs';
import { isUnread2u0ehyt0ioouz as isUnread } from '../../../extensions/HasReadBy.ext.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { unreadIconWhen1430ixd91bo9h as unreadIconWhen } from '../iconShortcuts.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance_0 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import { formatLong1m1koxnp4gvzx as formatLong } from '../../../../../../crowpay-shared/com/crowpay/timeFormatting.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  get_dp28ag147e4p5cz as get_dp,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { ButtonSemantic_getInstance2exl8jbak13ac as ButtonSemantic_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import {
  get_edit2tiiawv2658bs as get_edit,
  get_trash3qsdn4kaynjmu as get_trash,
} from '../../../icons.mjs';
import { resize3py5p2yrjp6p7 as resize } from '../../../utils/utils.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  get_deleteButton1v46c8rhktdg5 as get_deleteButton,
  DangerButtonSemantic_getInstanceb7gofax87736 as DangerButtonSemantic_getInstance,
} from '../../theming/buttons.mjs';
import { ProjectLens_Contractor_getInstance3hm6gxlnsv3ks as ProjectLens_Contractor_getInstance } from '../../screens/common/ProjectView.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../nav/AppDimensions.mjs';
import { renderFiles2vz7gmubfqcvp as renderFiles } from '../files/renderFiles.mjs';
import { label287uhiq3m9m4z as label2 } from '../label2.mjs';
import { lastOrNull1aq5oz189qoe1 as lastOrNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../../theming/separators.mjs';
import { JumpTo_getInstance3ru9x2o8nieur as JumpTo_getInstance } from '../../../utils/JumpTo.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance_1,
  toDuration7gy6v749ektt as toDuration,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MILLISECONDS_getInstance15owevua4zjxe as DurationUnit_MILLISECONDS_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../nav/crowpay.mjs';
import { CreateOrEditNote2axvnom01lmg9 as CreateOrEditNote } from '../../dialogs/CreateOrEditNote.mjs';
import { GenericConfirmationDialog172k63mmx5r2d as GenericConfirmationDialog } from '../../dialogs/GenericConfirmationDialog.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function renderContractorNotes(_this__u8e3s4, notes, groupName, lens_0, onJump) {
  var tmp;
  if (onJump === VOID) {
    tmp = renderContractorNotes$lambda;
  } else {
    tmp = onJump;
  }
  onJump = tmp;
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Frame())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  var tmp_0 = view.kbb(view.kbb(shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.daj(notes).i1()), get_centered(view)), view.jbb(NothingHereSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.zbm(true);
  // Inline function 'com.crowpay.views.theming.boldSubTitle' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (TextView())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_1.lba(view_1.qb6_1.abf(SubtitleSemantic_getInstance().abf(BoldSemantic_getInstance())));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value = 'Nothing Yet';
  var tmp_1 = view_1.vb5_1;
  var tmp_2;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value) === 0) {
    tmp_2 = '\xA0';
  } else {
    tmp_2 = value;
  }
  tmp_1.hbu(tmp_2);
  view_1.dbs(Align_Center_getInstance());
  view_0.hbb(p_1, view_1);
  // Inline function 'com.crowpay.views.theming.smallBody' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (TextView())(view_0.pc());
  var tmp0_elvis_lhs_2 = view_0.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
  view_0.gbb(p_2, view_2);
  view_2.lba(view_2.qb6_1.abf(SmallBodySemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value_0 = lens_0.zgj() ? 'Notes will appear here once created' : 'Press "+ Work Note" to add a note';
  var tmp_3 = view_2.vb5_1;
  var tmp_4;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value_0) === 0) {
    tmp_4 = '\xA0';
  } else {
    tmp_4 = value_0;
  }
  tmp_3.hbu(tmp_4);
  view_2.dbs(Align_Center_getInstance());
  view_0.hbb(p_2, view_2);
  view.hbb(p_0, view_0);
  view.lbb(tmp_0, view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_3 = view.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
  view.gbb(p_3, view_3);
  view_3.zbm(true);
  view_3.jb7(false);
  var tmp_5 = KMutableProperty0();
  var tmp_6 = RowOrCol$_get_shown_$ref_m8lfse(view_3);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('shown', 0, tmp_5, tmp_6, RowOrCol$_set_shown_$ref_7290m6(view_3));
  reactiveScope(view_3, ($this$reactiveScope) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    var tmp$ret$19 = !$this$reactiveScope.daj(notes).i1();
    this_0.set(tmp$ret$19);
    return Unit_instance;
  });
  forEachUpdating(view_3, notes, 0, ($this$forEachUpdating, note) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$forEachUpdating.pc());
    var tmp0_elvis_lhs = $this$forEachUpdating.ebb_1;
    var p = tmp0_elvis_lhs == null ? $this$forEachUpdating : tmp0_elvis_lhs;
    $this$forEachUpdating.gbb(p, view);
    view.zbm(true);
    var unread = remember(VOID, VOID, VOID, ($this$remember) => isUnread($this$remember.daj(note), $this$remember.daj(get_session()).gfv_1));
    launch(view, VOID, VOID, renderContractorNotes$lambda$slambda_0(note, view, onJump));
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_0 = view.ebb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.gbb(p_0, view_0);
    view_0.zbm(false);
    get_centered(view_0);
    unreadIconWhen(view_0, ($this$unreadIconWhen) => $this$unreadIconWhen.daj(unread));
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.minus' call
    Companion_getInstance_0();
    // Inline function 'com.crowpay.views.theming.subTitle' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (TextView())(view_0.pc());
    var tmp0_elvis_lhs_1 = view_0.ebb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
    view_0.gbb(p_1, view_1);
    view_1.lba(view_1.qb6_1.abf(SubtitleSemantic_getInstance()));
    var tmp = KMutableProperty0();
    var tmp_0 = TextView$_get_content_$ref_4pzcwl(view_1);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(view_1));
    reactiveScope(view_1, ($this$reactiveScope) => {
      // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
      var tmp$ret$23 = groupName($this$reactiveScope) + ' Notes';
      this_0.set(tmp$ret$23);
      return Unit_instance;
    });
    view_0.hbb(p_1, view_1);
    var tmp_1 = get_centered(view_0);
    // Inline function 'com.crowpay.views.theming.smallBody' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (TextView())(view_0.pc());
    var tmp0_elvis_lhs_2 = view_0.ebb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
    view_0.gbb(p_2, view_2);
    view_2.lba(view_2.qb6_1.abf(SmallBodySemantic_getInstance()));
    var tmp_2 = KMutableProperty0();
    var tmp_3 = TextView$_get_content_$ref_4pzcwl_0(view_2);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_1 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb_0(view_2));
    reactiveScope(view_2, ($this$reactiveScope) => {
      var tmp$ret$30 = formatLong($this$reactiveScope.daj(note).g5p_1);
      this_1.set(tmp$ret$30);
      return Unit_instance;
    });
    view_0.hbb(p_2, view_2);
    view_0.lbb(tmp_1, view_2);
    if (lens_0.equals(ProjectLens_Contractor_getInstance())) {
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_3 = new (RowOrCol())(view_0.pc());
      var tmp0_elvis_lhs_3 = view_0.ebb_1;
      var p_3 = tmp0_elvis_lhs_3 == null ? view_0 : tmp0_elvis_lhs_3;
      view_0.gbb(p_3, view_3);
      view_3.zbm(false);
      view_3.bb9(get_rem(0.5));
      // Inline function 'com.lightningkite.kiteui.views.direct.space' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_4 = new (Space())(view_3.pc());
      var tmp0_elvis_lhs_4 = view_3.ebb_1;
      var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
      view_3.gbb(p_4, view_4);
      view_3.hbb(p_4, view_4);
      // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
      var tmp_4 = view_3.jbb(ButtonSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_5 = new (Button())(view_3.pc());
      var tmp0_elvis_lhs_5 = view_3.ebb_1;
      var p_5 = tmp0_elvis_lhs_5 == null ? view_3 : tmp0_elvis_lhs_5;
      view_3.gbb(p_5, view_5);
      view_5.gba(get_dp(1));
      view_5.lbb(get_centered(view_5), icon(view_5, resize(get_edit(Companion_getInstance()), get_rem(1.1)), 'Edit'));
      onClick(view_5, VOID, VOID, renderContractorNotes$lambda$slambda_2(note));
      view_3.hbb(p_5, view_5);
      view_3.lbb(tmp_4, view_5);
      var tmp_5 = get_deleteButton(view_3);
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_6 = new (Button())(view_3.pc());
      var tmp0_elvis_lhs_6 = view_3.ebb_1;
      var p_6 = tmp0_elvis_lhs_6 == null ? view_3 : tmp0_elvis_lhs_6;
      view_3.gbb(p_6, view_6);
      view_6.gba(get_dp(1));
      view_6.lbb(get_centered(view_6), icon(view_6, resize(get_trash(Companion_getInstance()), get_rem(1.1)), 'Delete'));
      onClick(view_6, VOID, VOID, renderContractorNotes$lambda$slambda_4(note));
      view_3.hbb(p_6, view_6);
      view_3.lbb(tmp_5, view_6);
      view_0.hbb(p_3, view_3);
    }
    view.hbb(p_0, view_0);
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_7 = new (TextView())(view.pc());
    var tmp0_elvis_lhs_7 = view.ebb_1;
    var p_7 = tmp0_elvis_lhs_7 == null ? view : tmp0_elvis_lhs_7;
    view.gbb(p_7, view_7);
    view_7.lba(view_7.qb6_1.abf(BodySemantic_getInstance()));
    var tmp_6 = KMutableProperty0();
    var tmp_7 = TextView$_get_content_$ref_4pzcwl_1(view_7);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_2 = getPropertyCallableRef('content', 0, tmp_6, tmp_7, TextView$_set_content_$ref_pketfb_1(view_7));
    reactiveScope(view_7, ($this$reactiveScope) => {
      var tmp$ret$55 = $this$reactiveScope.daj(note).e5p_1;
      this_2.set(tmp$ret$55);
      return Unit_instance;
    });
    view.hbb(p_7, view_7);
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_8 = new (Frame())(view.pc());
    var tmp0_elvis_lhs_8 = view.ebb_1;
    var p_8 = tmp0_elvis_lhs_8 == null ? view : tmp0_elvis_lhs_8;
    view.gbb(p_8, view_8);
    var files = lens(note, renderContractorNotes$lambda$lambda);
    var tmp_8 = KMutableProperty0();
    var tmp_9 = Frame$_get_shown_$ref_dnks5k(view_8);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_3 = getPropertyCallableRef('shown', 0, tmp_8, tmp_9, Frame$_set_shown_$ref_s2otf0(view_8));
    reactiveScope(view_8, ($this$reactiveScope) => {
      // Inline function 'kotlin.collections.isNotEmpty' call
      var tmp$ret$63 = !$this$reactiveScope.daj(files).i1();
      this_3.set(tmp$ret$63);
      return Unit_instance;
    });
    label2(view_8, 'Files: ', VOID, ($this$label2) => renderFiles($this$label2, files, get_AppDimensions().tg2_1));
    view.hbb(p_8, view_8);
    greySeparator(view, ($this$greySeparator) => {
      var tmp = KMutableProperty0();
      var tmp_0 = Separator$_get_shown_$ref_e9a0og($this$greySeparator);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_0 = getPropertyCallableRef('shown', 0, tmp, tmp_0, Separator$_set_shown_$ref_f1kfq4($this$greySeparator));
      reactiveScope($this$greySeparator, ($this$reactiveScope) => {
        var tmp = $this$reactiveScope.daj(note).b5p_1;
        var tmp0_safe_receiver = lastOrNull($this$reactiveScope.daj(notes));
        var tmp$ret$68 = !tmp.equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b5p_1);
        this_0.set(tmp$ret$68);
        return Unit_instance;
      });
      return Unit_instance;
    });
    $this$forEachUpdating.hbb(p, view);
    return Unit_instance;
  });
  view.hbb(p_3, view_3);
  _this__u8e3s4.hbb(p, view);
}
function renderContractorNotes$lambda() {
  return Unit_instance;
}
function RowOrCol$_get_shown_$ref_m8lfse(p0) {
  return () => p0.yb8();
}
function RowOrCol$_set_shown_$ref_7290m6(p0) {
  return (_this__u8e3s4) => {
    p0.jb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  var tmp = JumpTo_getInstance().wg3_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.rh1_1;
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0.b5p_1;
  // Inline function 'kotlin.time.Companion.milliseconds' call
  Companion_getInstance_1();
  var tmp$ret$1 = toDuration(500, DurationUnit_MILLISECONDS_getInstance());
  tmp.yg4(tmp_1, $this.sh1_1, tmp$ret$1, $this.th1_1);
  return Unit_instance;
}
var renderContractorNotes$lambda$slambdaClass;
function renderContractorNotes$lambda$slambda() {
  if (renderContractorNotes$lambda$slambdaClass === VOID) {
    class $ {
      constructor($note, $$this$noteCol, $onJump) {
        this.rh1_1 = $note;
        this.sh1_1 = $$this$noteCol;
        this.th1_1 = $onJump;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    renderContractorNotes$lambda$slambdaClass = $;
  }
  return renderContractorNotes$lambda$slambdaClass;
}
function renderContractorNotes$lambda$slambda_0($note, $$this$noteCol, $onJump) {
  var i = new (renderContractorNotes$lambda$slambda())($note, $$this$noteCol, $onJump);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp = get_dialogStack();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.uh1_1;
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp$ret$0 = tmp_0;
  tmp.zgd(CreateOrEditNote().vh1(tmp$ret$0, null));
  return Unit_instance;
}
var renderContractorNotes$lambda$slambdaClass_0;
function renderContractorNotes$lambda$slambda_1() {
  if (renderContractorNotes$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($note) {
        this.uh1_1 = $note;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderContractorNotes$lambda$slambdaClass_0 = $;
  }
  return renderContractorNotes$lambda$slambdaClass_0;
}
function renderContractorNotes$lambda$slambda_2($note) {
  var i = new (renderContractorNotes$lambda$slambda_1())($note);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_1($this, it, $completion) {
  if (it) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_session();
    var tmp = await_0(this_0, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tmp_0 = tmp.bfw_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $this.wh1_1;
    var tmp_1 = await_0(this_1, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    var tmp$ret$1 = tmp_1;
    var tmp_2 = tmp_0.mft(tmp$ret$1.b5p_1).kem($completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
  }
  return Unit_instance;
}
var renderContractorNotes$lambda$slambda$slambdaClass;
function renderContractorNotes$lambda$slambda$slambda() {
  if (renderContractorNotes$lambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($note) {
        this.wh1_1 = $note;
      }
      egk(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, it), $completion);
      }
      s2(p1, $completion) {
        return this.egk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    renderContractorNotes$lambda$slambda$slambdaClass = $;
  }
  return renderContractorNotes$lambda$slambda$slambdaClass;
}
function renderContractorNotes$lambda$slambda$slambda_0($note) {
  var i = new (renderContractorNotes$lambda$slambda$slambda())($note);
  var l = (it, $completion) => i.egk(it, $completion);
  l.$arity = 1;
  return l;
}
var renderContractorNotes$lambda$slambdaClass_1;
function renderContractorNotes$lambda$slambda_3() {
  if (renderContractorNotes$lambda$slambdaClass_1 === VOID) {
    class $ {
      constructor($note) {
        this.xh1_1 = $note;
      }
      uao($completion) {
        var tmp = get_dialogStack();
        var tmp0_confirmationTheme = DangerButtonSemantic_getInstance();
        tmp.zgd(new (GenericConfirmationDialog())('Delete Note', 'Are you sure you want to delete this note?', VOID, 'Delete', VOID, tmp0_confirmationTheme, VOID, VOID, VOID, VOID, renderContractorNotes$lambda$slambda$slambda_0(this.xh1_1)));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderContractorNotes$lambda$slambdaClass_1 = $;
  }
  return renderContractorNotes$lambda$slambdaClass_1;
}
function renderContractorNotes$lambda$slambda_4($note) {
  var i = new (renderContractorNotes$lambda$slambda_3())($note);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function renderContractorNotes$lambda$lambda(it) {
  return it.f5p_1;
}
function Frame$_get_shown_$ref_dnks5k(p0) {
  return () => p0.yb8();
}
function Frame$_set_shown_$ref_s2otf0(p0) {
  return (_this__u8e3s4) => {
    p0.jb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function Separator$_get_shown_$ref_e9a0og(p0) {
  return () => p0.yb8();
}
function Separator$_set_shown_$ref_f1kfq4(p0) {
  return (_this__u8e3s4) => {
    p0.jb7(_this__u8e3s4);
    return Unit_instance;
  };
}
//region block: exports
export {
  renderContractorNotes as renderContractorNotes38zg0r7j0ume5,
};
//endregion

//# sourceMappingURL=renderContractorNotes.mjs.map
